import script from "./DeveloperLandingPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeveloperLandingPage.vue?vue&type=script&lang=ts&setup=true"

import "./DeveloperLandingPage.vue?vue&type=style&index=0&id=19d6f9aa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19d6f9aa"]])

export default __exports__